import React, { useEffect, useState, useRef } from "react";
import {
  getHeaderList,
  getVSATHeaderList,
  getPartnersHeaderList,
  getRetiredHeaderList,
  getEnglishHeaderList,
} from "../../services/header/header.service";
import { useLocation, useNavigate, Link } from "react-router-dom";
import styles from "./Header.module.css";
import { BottomSheet } from "react-spring-bottom-sheet";
// import component 👇
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import "react-spring-bottom-sheet/dist/style.css";
import { getSearchNews } from "../../services/news/news.service";
import { getSearchProducts } from "../../services/product/product.service";
import MobileNewsSearch from "../mobile-news-search";
import MobileProductSearch from "../mobile-product-search";
import { toast, ToastContainer } from "react-toastify";
let debounce = null;

const popularSearch = [
  // {
  //   title: "محصولات",
  //   url: "/product/list",
  // },
  {
    title: "اخبار",
    url: "/news/list",
  },
  {
    title: "درباره ما",
    url: "/about?t=IscIntroduction",
  },
  {
    title: "بانکداری",
    url: "/search?q=بانکداری",
  },
  // {
  //   title: "VSAT",
  //   url: "/vsat",
  // },
  {
    title: "سهامداران",
    url: "/partners",
  },
  {
    title: "بازنشستگان",
    url: "/retired",
  },
];

let listener = null;
const Header = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [mobileSearchNews, setMobileSearchNews] = useState([]);
  const [mobileSearchProducts, setMobileSearchProducts] = useState([]);
  const isMobile = useState(window.mobileCheck());
  const navbarWrapperRef = useRef();
  const [isOpen, setIsOpen] = useState(false);
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const location = useLocation();
  const [selectedMenu, setSelectedMenu] = useState("");
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [menuItems, setMenuItems] = useState([]);
  const [landing, setLanding] = useState("");
  const [isEnglish, setIsEnglish] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [subStep, setSubStep] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const [subItems, setSubItems] = useState([]);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const search = () => {
    if (searchInput.length > 1) {
      if (
        /^[\u0600-\u06FFa-zA-Z0-9-_.،\s]+$/.test(searchInput) &&
        searchInput.indexOf('"') < 0 &&
        searchInput.indexOf("'") < 0
      ) {
        navigate("/search?q=" + searchInput);
      } else {
        toast.error("عبارت وارد شده صحیح نیست");
      }
    }
  };
  useEffect(() => {
    if (window.location.href.indexOf("/en") >= 0) {
      setIsEnglish(true);
      getEnglishHeaderList().then((data) => {
        setItems((data && data.data && data.data.data) || []);
        setMenuItems((data && data.data && data.data.data) || []);
      });
    } else {
      setIsEnglish(false);
      if (window.location.href.indexOf("/vsat") >= 0) {
        getVSATHeaderList().then((data) => {
          setItems((data && data.data && data.data.data) || []);
          setMenuItems((data && data.data && data.data.data) || []);
        });
      } else if (window.location.href.indexOf("/partners") >= 0) {
        getPartnersHeaderList().then((data) => {
          setItems((data && data.data && data.data.data) || []);
          setMenuItems((data && data.data && data.data.data) || []);
        });
      } else if (window.location.href.indexOf("/retired") >= 0) {
        getRetiredHeaderList().then((data) => {
          setItems((data && data.data && data.data.data) || []);
          setMenuItems((data && data.data && data.data.data) || []);
        });
      } else {
        getHeaderList().then((data) => {
          setItems((data && data.data && data.data.data) || []);
          setMenuItems((data && data.data && data.data.data) || []);
        });
      }
    }
    if (isMobile) {
      onDismiss();
      setIsMobileNavOpen(false);
    }
  }, [location]);

  useEffect(() => {
    setIsOpen(false);
    if (location.pathname.indexOf("/retired") >= 0) {
      setLanding("retired");
    } else if (location.pathname.indexOf("/vsat") >= 0) {
      setLanding("vsat");
    } else if (location.pathname.indexOf("/partners") >= 0) {
      setLanding("partners");
    } else if (location.pathname.indexOf("/retired") >= 0) {
      setLanding("partners");
    } else {
      setLanding("");
    }
    setSelectedMenu("");
    setIsOpen(false);
    setSubStep(0);
  }, [location]);

  useEffect(() => {
    var lastScrollTop = 0;
    if (!isOpen) {
      listener = window.addEventListener(
        "scroll",
        function () {
          const menuEl = document.getElementById("mega-menu-wrapper");
          if (navbarWrapperRef && navbarWrapperRef.current && !menuEl) {
            var st = window.pageYOffset || document.documentElement.scrollTop;
            if (st > lastScrollTop) {
              navbarWrapperRef.current.style.top = "-160px";
            } else if (st < lastScrollTop) {
              navbarWrapperRef.current.style.top = 0;
            }
            lastScrollTop = st <= 0 ? 0 : st;
          }
        },
        false
      );
    } else {
      window.removeEventListener("scroll", listener);
    }
  }, [isOpen]);
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      if (searchInput.length > 1) {
        search();
        setMobileOpen(false);
      }
    }
  };
  const handleOpenMenu = (item = {}) => {
    const el = document.getElementsByTagName("html")[0];
    if (isOpen && subItems.title === item.title) {
      setSubItems([]);
      setSelectedMenu("");
    } else {
      setSubItems(item);
      setSelectedMenu(item.title);
    }
    if (Object.keys(item).length > 0) {
      if (item.title === subItems.title) {
        setIsOpen(!isOpen);
      } else {
        setIsOpen(true);
      }
    } else {
      document.body?.removeAttribute("style");
      el.removeAttribute("style");
      setIsOpen(!isOpen);
    }
  };
  const handleGoBack = () => {
    const nextStep = subStep - 1;
    if (nextStep > 0) {
      setSubStep(nextStep);
      setMenuItems([...subItems]);
    } else {
      setMenuItems([...items]);
      setSubStep(0);
    }
  };
  const handleMobileMenu = function (el) {
    setSubStep(subStep + 1);
    const title = el.title;
    const selecteItem = menuItems.find((item) => title === item.title);
    setMenuItems(selecteItem.children);
  };
  const handleLanguage = () => {
    if (isEnglish) {
      navigate("/");
      setIsEnglish(false);
    } else {
      navigate("/en");
      setIsEnglish(true);
    }
  };
  const handleMobileToggleMenu = () => {
    setMenuItems([...items]);
    setSubStep(0);
    setIsMobileNavOpen(!isMobileNavOpen);
  };
  function handleMobileSearch() {
    setMobileOpen(true);
  }
  function onDismiss() {
    setMobileSearchNews([]);
    setMobileSearchProducts([]);
    setSearchInput("");
    setMobileOpen(false);
  }
  return (
    <>
      <ToastContainer />
      {isOpen && (
        <div className={styles.menuOverlay} onClick={() => handleOpenMenu()} />
      )}
      <div className={styles.navbarWrapper} ref={navbarWrapperRef}>
        <div className={styles.topNav}>
          <div className="container">
            <div className={styles.navLinks}>
              <div className={styles.linksItem}>
                <ul className={styles.linksList}>
                  <li className={landing === "" ? styles.activeLink : null}>
                    <Link to={"/"}>
                      <i className={`fa fa-home ${styles.icon}`} /> خانه
                    </Link>
                  </li>
                  <li
                    className={
                      landing === "partners" ? styles.activeLink : null
                    }
                  >
                    <Link to={"/partners"}>سهامداران</Link>
                  </li>
                  <li
                    className={landing === "retired" ? styles.activeLink : null}
                  >
                    <Link to={"/retired"}>بازنشستگان</Link>
                  </li>
                  {/* <li className={landing === "vsat" ? styles.activeLink : null}>
                    <Link to={"/vsat"}>VSAT</Link>
                  </li> */}
                </ul>
              </div>
              {/*
                <div className={styles.linksForLeft}>
                 <div
                  className={styles.languageSwitchBtn}
                  onClick={handleLanguage}
                >
                  <div
                    className={
                      isEnglish
                        ? `${styles.switchBtn} ${styles.switchedEng}`
                        : styles.switchBtn
                    }
                  >
                    {isEnglish ? "EN" : "فا"}
                  </div>
                </div> 
              </div>
              */}
            </div>
          </div>
        </div>
        <div
          className={
            isEnglish
              ? `${styles.mainNav} en-menu-on-left-side`
              : styles.mainNav
          }
        >
          <div className="container">
            <div
              className={
                isEnglish ? `${styles.menus} ${styles.menusEn}` : styles.menus
              }
            >
              <div
                className={
                  isEnglish
                    ? `${styles.menuRight} ${styles.menuDirection}`
                    : styles.menuRight
                }
              >
                <div
                  className={`visible-xs visible-sm ${styles.mobileMenu}`}
                  onClick={handleMobileToggleMenu}
                >
                  <i className={isOpen ? "fa fa-close" : "fa fa-navicon"} />
                </div>
                <div className={styles.logoItem}>
                  <Link to={"/"}>
                    <img
                      src={"/assets/image/logo-header-reverse.png"}
                      alt={"logo"}
                    />
                  </Link>
                </div>
                <ul
                  className={
                    isEnglish
                      ? `hidden-xs ${styles.menuItems} ${styles.menuItemsEn}`
                      : `hidden-xs ${styles.menuItems}`
                  }
                >
                  {items.map((el, index) => (
                    <li
                      key={`menu-items-${index}`}
                      className={
                        el.title === selectedMenu ? styles.activeMenu : ""
                      }
                    >
                      {Array.isArray(el.children) && el.children.length > 0 ? (
                        <div onClick={() => handleOpenMenu(el)}>
                          {el.title}
                          {selectedMenu === el.title ? (
                            <i className="fa fa-angle-up" />
                          ) : (
                            <i className="fa fa-angle-down" />
                          )}
                        </div>
                      ) : el.destination_url &&
                        el.destination_url.startsWith("http") ? (
                        <a target="_blank" href={el.destination_url}>
                          {el.title}
                        </a>
                      ) : (
                        <Link
                          to={
                            el.destination_url &&
                            el.destination_url.trim().length > 1
                              ? el.destination_url.trim().startsWith("/")
                                ? el.destination_url.trim()
                                : "/" + el.destination_url.trim()
                              : "/404"
                          }
                        >
                          {el.title}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
                <Drawer
                  open={isMobileNavOpen}
                  direction={isEnglish ? "left" : "right"}
                  onClose={() => {
                    const el = document.getElementsByTagName("html")[0];
                    el.removeAttribute("style");
                    setMenuItems([...items]);
                    setSubStep(0);
                    setIsMobileNavOpen(false);
                  }}
                >
                  <ul className={styles.mobileNav}>
                    <li className={isEnglish ? styles.goBackEn : styles.goBack}>
                      <div>
                        {subStep > 0 && (
                          <div onClick={handleGoBack}>
                            {!isEnglish && (
                              <i className={"fa fa-angle-right"} />
                            )}
                            {isEnglish ? "Back" : "بازگشت"}
                            {isEnglish && <i className={"fa fa-angle-left"} />}
                          </div>
                        )}
                      </div>
                      <div
                        onClick={() => {
                          const el = document.getElementsByTagName("html")[0];
                          el.removeAttribute("style");
                          setMenuItems([...items]);
                          setSubStep(0);
                          setIsMobileNavOpen(false);
                        }}
                      >
                        <i className="fa fa-close"></i>
                      </div>
                    </li>
                    {(menuItems || []).map((el, index) => (
                      <li key={`menu-items-${index}`}>
                        {Array.isArray(el.children) &&
                        el.children.length > 0 ? (
                          <div
                            className={isEnglish ? styles.englishMenuRow : ""}
                            onClick={() => {
                              setSubItems([...menuItems]);
                              handleMobileMenu(el);
                            }}
                          >
                            <div>
                              {el.icon && <i className={el.icon} />}
                              {el.title}
                            </div>
                            <div>
                              {!isEnglish && <i className="fa fa-angle-left" />}
                              {isEnglish && <i className="fa fa-angle-right" />}
                            </div>
                          </div>
                        ) : el.destination_url &&
                          el.destination_url.startsWith("http") ? (
                          <a
                            className={isEnglish ? styles.englishLinkRow : ""}
                            to={el.destination_url}
                          >
                            {el.title}
                          </a>
                        ) : (
                          <Link
                            className={isEnglish ? styles.englishLinkRow : ""}
                            to={
                              el.destination_url &&
                              el.destination_url.trim().length > 1
                                ? el.destination_url.trim().startsWith("/")
                                  ? el.destination_url.trim()
                                  : "/" + el.destination_url.trim()
                                : "/404"
                            }
                          >
                            {el.icon && <i className={el.icon} />}
                            {el.title}
                          </Link>
                        )}
                      </li>
                    ))}
                  </ul>
                </Drawer>
              </div>
              <div className={isEnglish ? styles.menuLeftEn : styles.menuLeft}>
                <div
                  className={
                    isEnglish
                      ? `${styles.searchItem} ${styles.searchItemEn}`
                      : styles.searchItem
                  }
                >
                  <input
                    className={searchOpen ? styles.searchInputOpen : ""}
                    type="search"
                    placeholder={isEnglish ? "search" : "جستجو"}
                    onInput={(e) => setSearchInput(e.target.value)}
                    value={searchInput}
                    onKeyDown={handleKeyDown}
                  />
                  {searchOpen && (
                    <div
                      onClick={() => setSearchOpen(false)}
                      className={
                        isEnglish
                          ? `${styles.searchToggleButtonRemoveOpen} ${styles.searchToggleButtonRemoveOpenEn}`
                          : styles.searchToggleButtonRemoveOpen
                      }
                    >
                      <i className="fa fa-remove" />
                    </div>
                  )}
                  <div
                    onClick={() =>
                      isMobile[0]
                        ? handleMobileSearch()
                        : searchOpen
                        ? search(searchInput)
                        : setSearchOpen(!searchOpen)
                    }
                    className={
                      !searchOpen
                        ? isEnglish
                          ? `${styles.searchToggleButton} ${styles.searchToggleButtonEn}`
                          : styles.searchToggleButton
                        : isEnglish
                        ? `${styles.searchToggleButtonOpen} ${styles.searchToggleButtonOpenEn}`
                        : styles.searchToggleButtonOpen
                    }
                  >
                    <i className="fa fa-search" />
                  </div>
                </div>
                <Link to={"/job/intro"} className={styles.linkToJob}>
                  <span>همکاری با ما</span>
                </Link>
              </div>
            </div>
          </div>
          {isOpen && (
            <MegaMenuElem
              className={"hidden-xs"}
              items={subItems}
              isEnglish={isEnglish}
            />
          )}
        </div>
        <BottomSheet
          open={mobileOpen}
          snapPoints={({ minHeight, maxHeight }) => [
            minHeight + 200,
            maxHeight - 200,
          ]}
          style={{
            zIndex: 1000,
          }}
          onDismiss={onDismiss}
          onSpringEnd={(event) => {
            if (event.type === "SNAP" && event.source === "snap-to-bottom") {
              setMobileOpen(false);
            }
          }}
        >
          <div
            className={
              !isEnglish ? styles.searchTitleSheet : styles.searchTitleSheetEn
            }
          >
            {!isEnglish ? "جستجو" : "Search"}
          </div>
          <div className={styles.searchWrapperContainer}>
            <input
              className={
                isEnglish
                  ? styles.mobileSearchInputEn
                  : styles.mobileSearchInput
              }
              type="search"
              onInput={(e) => {
                setSearchInput(e.target.value);
                if (debounce) {
                  clearTimeout(debounce);
                }
                setLoading(true);
                debounce = setTimeout(function () {
                  const items = [
                    getSearchNews(0, searchInput),
                    getSearchProducts(0, searchInput),
                  ];
                  if (e.target.value.length >= 3) {
                    Promise.allSettled(items)
                      .then((data) => {
                        setLoading(false);
                        setMobileSearchNews(data[0].value?.data?.data?.data);
                        setMobileSearchProducts(
                          data[1].value?.data?.data?.data
                        );
                      })
                      .catch(() => {});
                  } else {
                    setLoading(false);
                    setMobileSearchNews([]);
                    setMobileSearchProducts([]);
                  }
                }, 1000);
              }}
              value={searchInput}
              onKeyDown={(e) => {
                handleKeyDown(e);
              }}
            />
            <div
              className={
                isEnglish ? styles.mobileSearchItemEn : styles.mobileSearchItem
              }
              onClick={() => {
                search();
                setMobileOpen(false);
              }}
            >
              <i className="fa fa-search" />
            </div>
          </div>
          <div
            className={
              isEnglish
                ? styles.popularSearchTitleEn
                : styles.popularSearchTitle
            }
          >
            <i className="fa fa-star"></i>
            {isEnglish ? "Popular Search" : "جستجوهای پرطرفدار"}
          </div>
          <div
            className={
              isEnglish ? styles.scrollOnMobileEn : styles.scrollOnMobile
            }
          >
            <ul>
              {popularSearch.map((item, index) => (
                <li key={`popular-search-${index}`}>
                  <Link to={item.url}>
                    {isEnglish && <i className="fa fa-angle-right"></i>}
                    {item.title}
                    {!isEnglish && <i className="fa fa-angle-left"></i>}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <ul
            className={isEnglish ? styles.tabForSearchEn : styles.tabForSearch}
          >
            <li
              onClick={() => setActiveTab(0)}
              className={activeTab === 0 ? styles.activeTab : ``}
            >
              {!isEnglish ? "اخبار" : "news"}
            </li>
            <li
              onClick={() => setActiveTab(1)}
              className={activeTab === 1 ? styles.activeTab : ``}
            >
              {!isEnglish ? "محصولات" : "products"}
            </li>
          </ul>
          <div className={styles.searchResult}>
            {loading ? (
              <div className={styles.loading}>
                <img src={"../../assets/image/loading.svg"} alt={"loading"} />
              </div>
            ) : (
              <div className={styles.searchResultsWrapper}>
                {activeTab === 0 && (
                  <div className={styles.searchResultsContainer}>
                    {Array.isArray(mobileSearchNews) &&
                    mobileSearchNews.length > 0 ? (
                      <>
                        <div className="col-xs-12">
                          {mobileSearchNews.map((item, index) => (
                            <>
                              <div key={`mobile-search-news-${index}`}>
                                <MobileNewsSearch item={item} />
                              </div>
                            </>
                          ))}
                        </div>
                      </>
                    ) : (
                      <div className={styles.noSearchResult}>
                        <div className={styles.noSearchResultImage}>
                          <img
                            src={"/assets/image/no-search.jpg"}
                            alt={"جستجو خدمات انفورماتیک"}
                          />
                        </div>
                        <div className={styles.noSearchResultText}>
                          نتیجه ای یافت نشد
                        </div>
                      </div>
                    )}
                  </div>
                )}
                {activeTab === 1 && (
                  <div className={styles.searchResultsContainer}>
                    {Array.isArray(mobileSearchProducts) &&
                    mobileSearchProducts.length > 0 ? (
                      <>
                        <div className="col-xs-12">
                          {mobileSearchProducts.map((item, index) => (
                            <div
                              key={`mobile-search-product-${index}`}
                              onClick={() => onDismiss()}
                            >
                              <MobileProductSearch item={item} />
                            </div>
                          ))}
                        </div>
                      </>
                    ) : (
                      <div className={styles.noSearchResult}>
                        <div className={styles.noSearchResultImage}>
                          <img
                            src={"/assets/image/no-search.jpg"}
                            alt={"جستجو خدمات انفورماتیک"}
                          />
                        </div>
                        <div className={styles.noSearchResultText}>
                          نتیجه ای یافت نشد
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        </BottomSheet>
      </div>
    </>
  );
};

const MegaMenuElem = ({ items, isEnglish }) => {
  return (
    <div className="container" id={"mega-menu-wrapper"}>
      <div className={styles.menuWrapper}>
        <div className={`hidden-xs ${styles.menuHover}`}>
          <div
            className={
              isEnglish
                ? `${styles.menuImage} ${styles.menuImageEn}`
                : styles.menuImage
            }
          >
            <img
              src={"/assets/image/menu-image.png"}
              alt={"منوی شرکت خدمات انفورماتیک"}
            />
          </div>
          <div
            className={
              !isEnglish
                ? styles.menuList
                : `${styles.menuList} ${styles.menuListEn}`
            }
          >
            {(items?.children || []).map((item, index) => (
              <div key={`menu-header-${index}`}>
                <div className={styles.menuHeader}>
                  {Array.isArray(item.children) && item.children.length > 0 ? (
                    item.title
                  ) : item.destination_url &&
                    item.destination_url.startsWith("http") ? (
                    <a target="_blank" href={item.destination_url}>
                      {item.title}
                    </a>
                  ) : (
                    <Link
                      to={
                        item.destination_url &&
                        item.destination_url.trim().length > 1
                          ? item.destination_url.trim().startsWith("/")
                            ? item.destination_url.trim()
                            : "/" + item.destination_url.trim()
                          : "/404"
                      }
                    >
                      {item.title} <i className="fa fa-angle-left" />
                    </Link>
                  )}
                </div>
                <ul className={styles.subItemElems}>
                  {(item.children || []).map((el, i) => (
                    <li key={`sub-menu-${i}`}>
                      {el.destination_url &&
                      el.destination_url.startsWith("http") ? (
                        <a target="_blank" href={el.destination_url}>
                          {el.title}
                        </a>
                      ) : (
                        <Link
                          to={
                            el.destination_url &&
                            el.destination_url.trim().length > 1
                              ? el.destination_url.trim().startsWith("/")
                                ? el.destination_url.trim()
                                : "/" + el.destination_url.trim()
                              : "/404"
                          }
                          className={styles.linkToElem}
                        >
                          {el.title}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
